import { AnimationData } from "../assets/glb/animations";
import api from "../service/api";

export function checkRepeatAnimation(
  oldAnimations: AnimationData[],
  newAnimations: AnimationData[]
) {
  let sizeReferenceArray: AnimationData[];
  let comparasionArray: AnimationData[];
  if (oldAnimations.length > newAnimations.length) {
    sizeReferenceArray = newAnimations;
    comparasionArray = oldAnimations;
  } else {
    sizeReferenceArray = oldAnimations;
    comparasionArray = newAnimations;
  }

  return !sizeReferenceArray.some(
    (animationRef, index) =>
      animationRef.glosa !== comparasionArray[index].glosa
  );
}

export function getSplittedTokens(tokens: string): string[] {
  return tokens.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/[- ]+/);
}

export function handleAnimationOrder(
  glosas: string,
  animations: AnimationData[]
): AnimationData[] {
  const animationsInOrder: AnimationData[] = [];
  getSplittedTokens(glosas).forEach((glosa) => {
    const foundAnimation = animations.find(
      (animation) => animation.glosa === glosa
    );
    if (foundAnimation) animationsInOrder.push(foundAnimation);
  });

  return animationsInOrder;
}

export async function getAnimationByTokens(
  tokens: string
): Promise<AnimationData[]> {
  const glosas = getSplittedTokens(tokens);
  const animations = await api
    .post("/glossary/animations/bytokens", {
      tokens: glosas,
      withCredentials: true,
    })
    .then((response) => response.data.items)
    .then((data: AnimationData[]) => {
      return data;
    });

  const animationsInOrder = handleAnimationOrder(tokens, animations);

  return animationsInOrder;
}
